// import React, { useMemo } from "react";
// import TableContainer from "Common/TableContainer";

// import { ordersList } from "Common/data";
// import { Link } from "react-router-dom";
// import { Dropdown } from "react-bootstrap";

// const ListViewTable = () => {
//   const columns = useMemo(
//     () => [
//       {
//         Header: (
//           <div className="form-check">
//             <input
//               className="form-check-input"
//               type="checkbox"
//               id="checkAll"
//               value="option"
//             />
//           </div>
//         ),
//         Cell: (cellProps: any) => {
//           return (
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 name="chk_child"
//                 defaultValue="option1"
//               />
//             </div>
//           );
//         },
//         id: "#",
//       },
//       {
//         Header: "Order ID",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <Link to="#" className="fw-medium link-primary">
//               {cellProps.orderId}
//             </Link>
//           );
//         },
//       },
//       {
//         Header: "Customer",
//         accessor: "customer_name",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Product Name",
//         accessor: "product_name",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Amount",
//         accessor: "amount",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Order Date",
//         accessor: "order_date",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Delivery Date",
//         accessor: "delivery_date",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Payment Method",
//         accessor: "payment_method",
//         disableFilters: true,
//         filterable: true,
//       },
//       {
//         Header: "Status",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           switch (cellProps.status) {
//             case "Delivered":
//               return (
//                 <span className="badge bg-success-subtle text-success text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             case "Cancelled":
//               return (
//                 <span className="badge bg-danger-subtle text-danger text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             case "Pending":
//               return (
//                 <span className="badge bg-warning-subtle text-warning text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             case "Inprogress":
//               return (
//                 <span className="badge bg-secondary-subtle text-secondary text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             case "Returns":
//               return (
//                 <span className="badge bg-primary-subtle text-primary text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//             default:
//               return (
//                 <span className="badge bg-success-subtle text-success text-uppercase">
//                   {" "}
//                   {cellProps.status}
//                 </span>
//               );
//           }
//         },
//       },
//       {
//         Header: "Action",
//         disableFilters: true,
//         filterable: true,
//         accessor: (cellProps: any) => {
//           return (
//             <React.Fragment>
//               <Dropdown className="text-center">
//                 <Dropdown.Toggle
//                   href="#!"
//                   className="btn btn-soft-secondary btn-sm btn-icon dropdown arrow-none"
//                 >
//                   <i className="mdi mdi-dots-horizontal" />
//                 </Dropdown.Toggle>
//                 <Dropdown.Menu as="ul" className="dropdown-menu-end">
//                   <li>
//                     <Dropdown.Item href="/orders-overview">
//                       <i className="ri-eye-fill align-bottom me-2 text-muted" />{" "}
//                       View
//                     </Dropdown.Item>
//                   </li>
//                   <li>
//                     <Dropdown.Item href="#" className="remove-list">
//                       <i className="ri-delete-bin-fill align-bottom me-2 text-muted" />
//                       Delete
//                     </Dropdown.Item>
//                   </li>
//                 </Dropdown.Menu>
//               </Dropdown>
//             </React.Fragment>
//           );
//         },
//       },
//     ],
//     []
//   );

//   return (
//     <React.Fragment>
//       <TableContainer
//         columns={columns || []}
//         data={ordersList || []}
//         // isGlobalFilter={false}
//         iscustomPageSize={false}
//         isBordered={false}
//         customPageSize={10}
//         className="custom-header-css"
//         tableClass="table-centered align-middle table-nowrap mb-0"
//         theadClass="text-muted table-light"
//         SearchPlaceholder="Search Products..."
//       />
//     </React.Fragment>
//   );
// };

// export default ListViewTable;

import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "Common/TableContainer";
import { Form, Link } from "react-router-dom";
import { Button, Dropdown, Modal } from "react-bootstrap";
import {
  fetchOrder,
  fetchOrders,
  updateItemStatus,
  updateOrderStatusById,
} from "api/apis";
import { Order, User } from "interface";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// interface Order {
//   _id: string;
//   total: number;
//   created: string;
//   products: Array<{
//     product: {
//       price: any;
//       name: string;
//       imageUrls: string[]; // Add this
//     };
//     status: string;
//   }>;
//   // Add other fields as needed from your backend
// }

interface PaginatedOrdersResponse {
  orders: Order[];
  user: string;
  totalPages: number;
  currentPage: number;
  count: number;
}

interface Filters {
  searchText: string;
  selectedDate: Date | null;
  selectedStatus: string;
  selectedPayment: string;
}
interface ListViewTableProps {
  filters: Filters;
}

const ListViewTable: React.FC<ListViewTableProps> = ({ filters }) => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1, // 1-based for API
    limit: 10,
    totalPages: 1,
    totalCount: 0,
  });

  const [error, setError] = useState<string | null>(null);

  const [modal_AddOrderModals, setModal_AddOrderModals] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const tog_AddOrderModals = () => {
    setModal_AddOrderModals(!modal_AddOrderModals);
  };

  useEffect(() => {
    console.log("Orders data:", orders);
  }, [orders]);

  const handleEditClick = (order: Order) => {
    setSelectedOrder(order);
    setModal_AddOrderModals(true);
  };

  const loadOrders = async (page: number = 1) => {
    try {
      setLoading(true);
      const data = await fetchOrders(page, pagination.limit);
      console.log("Hello world : ", data);
      setOrders(data.orders);
      console.log(data.orders);
      setPagination({
        ...pagination,
        currentPage: data.currentPage,
        totalPages: data.totalPages,
        totalCount: data.count,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Filters changed:", filters);
    // You can trigger a re-fetch or filter locally here if needed
  }, [filters]);

  useEffect(() => {
    const loadOrders = async () => {
      try {
        setLoading(true);
        const data = await fetchOrders(
          pagination.currentPage,
          pagination.limit
        );
        // console.log("datya", data);
        console.log("Checking :", data);

        setOrders(data.orders);

        // if (Array.isArray(data.user)) {
        //   data.user.forEach((item, index) => {
        //     console.log(`User ${index + 1}:`, item.user.firstName);
        //     setFirstName(item.user.firstName);
        //   });
        // }

        setPagination((prev) => ({
          ...prev,
          totalPages: data.totalPages,
          totalCount: data.count,
        }));
      } catch (error) {
        console.error("Error loading orders:", error);
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, [pagination.currentPage, pagination.limit]);

  // const transformedOrders = useMemo(() => {
  //   return orders.map((order, index) => ({
  //     id: index + 1,
  //     orderId: `#${order._id.substring(0, 8).toUpperCase()}`,
  //     customer_name: "Customer Name", // Replace with actual customer name from your data
  //     product_name: order.products?.[0]?.product?.name || "Unknown Product",
  //     amount: `₹${order.products?.[0]?.product?.price}`, // Assuming total is in cents
  //     order_date: new Date(order.created).toLocaleDateString("en-US", {
  //       day: "numeric",
  //       month: "short",
  //       year: "numeric",
  //     }),
  //     delivery_date: "N/A", // Add actual delivery date if available
  //     payment_method: "COD", // Replace with actual payment method
  //     status: order.products?.[0]?.status || "Not processed",
  //     _id: order._id, // Keep original ID for actions
  //   }));
  // }, [orders]);

  // const transformedOrders = useMemo(() => {
  //   return orders.map((order, index) => {
  //     const product = order.products?.[0]?.product;
  //     const productImage = product?.imageUrls?.[0] || "";

  //     return {
  //       id: index + 1,
  //       orderId: `#${order._id.substring(0, 8).toUpperCase()}`,
  //       customer_name: "Customer Name",
  //       product_name: {
  //         name: product?.name || "Unknown Product",
  //         image: productImage,
  //       },
  //       amount: `₹${product?.price}`,
  //       order_date: new Date(order.created).toLocaleDateString("en-US", {
  //         day: "numeric",
  //         month: "short",
  //         year: "numeric",
  //       }),
  //       delivery_date: "N/A",
  //       payment_method: "COD",
  //       status: order.products?.[0]?.status || "Not processed",
  //       _id: order._id,
  //     };
  //   });
  // }, [orders]);

  const transformedOrders = useMemo(() => {
    return orders
      .map((order, orderIndex) => {
        const product = order.products?.[0]?.product; // Taking first product for display
        const productImage = product?.imageUrls?.[0] || "";
        const customerName = order.user?.firstName || "Unknown Customer";
        const orderDate = new Date(order.created);
        const formattedOrderDate = orderDate.toLocaleDateString("en-US", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });

        // Apply filters
        const matchesSearch =
          filters.searchText === "" ||
          order._id.toLowerCase().includes(filters.searchText.toLowerCase()) ||
          customerName
            .toLowerCase()
            .includes(filters.searchText.toLowerCase()) ||
          product?.name
            .toLowerCase()
            .includes(filters.searchText.toLowerCase()) ||
          order.status.toLowerCase().includes(filters.searchText.toLowerCase());

        const matchesDate =
          !filters.selectedDate ||
          (orderDate.getDate() === filters.selectedDate.getDate() &&
            orderDate.getMonth() === filters.selectedDate.getMonth() &&
            orderDate.getFullYear() === filters.selectedDate.getFullYear());

        const matchesStatus =
          filters.selectedStatus === "all" ||
          order.status === filters.selectedStatus;

        const matchesPayment =
          filters.selectedPayment === "all" ||
          (filters.selectedPayment === "Online" &&
            order.paymentMethod !== "COD") ||
          (filters.selectedPayment === "COD" && order.paymentMethod === "COD");

        if (
          !matchesSearch ||
          !matchesDate ||
          !matchesStatus ||
          !matchesPayment
        ) {
          return null; // Skip this order if it doesn't match filters
        }

        return {
          id: `${orderIndex + 1}`,
          orderId: `#${order._id.substring(0, 8).toUpperCase()}`,
          customer_name: customerName,
          products: order.products, // Pass the full products array
          amount: `₹${order.total || 0}`,
          order_date: formattedOrderDate,
          delivery_date: "N/A",
          payment_method: order.paymentMethod,
          status: order?.status || "Not processed",
          _id: order._id,
        };
      })
      .filter(Boolean); // Remove null entries from the array
  }, [orders, filters]);

  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: newPage,
    }));
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPagination((prev) => ({
      ...prev,
      limit: newLimit,
      currentPage: 1, // Reset to first page when changing page size
    }));
  };

  // Complete columns array - replace your existing columns definition with this
  // Complete columns array - replace your existing columns definition with this
  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkAll"
              value="option"
            />
          </div>
        ),
        Cell: () => (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="chk_child"
              value="option1"
            />
          </div>
        ),
        id: "checkbox",
      },
      {
        Header: "Order ID",
        accessor: "orderId",
        disableFilters: true,
        filterable: true,
        Cell: ({ row }: { row: { original: any } }) => {
          // Find the original order data from the orders array
          const transformedOrder = row.original;
          const originalOrder = orders.find(
            (order) => order._id === transformedOrder._id
          );

          const handleOrderClick = async (orderId: string) => {
            try {
              console.log("Fetching detailed order data for ID:", orderId);

              // Call the fetchOrder API
              const detailedOrderData = await fetchOrder(orderId);
              console.log("detailed order data: ", detailedOrderData);

              // Console all the detailed order data
              console.log("=== DETAILED ORDER DATA ===");
              console.log("Complete Order Details:", detailedOrderData);

              if (detailedOrderData?.order?.products) {
                console.log(
                  "Products in Order:",
                  detailedOrderData.order.products
                );
                detailedOrderData.order.products.forEach(
                  (productItem: any, index: number) => {
                    console.log(`Product ${index + 1}:`, productItem);

                    // Log the _id of the product item (not the nested product)
                    console.log(`Product ${index + 1} _id:`, productItem._id);
                  }
                );
              }

              if (detailedOrderData.customer) {
                console.log("Customer Details:", detailedOrderData.customer);
              }

              console.log("Order Status:", detailedOrderData?.order?.status);
              console.log("Order Total:", detailedOrderData.total);
              console.log("Order Date:", detailedOrderData.created);
            } catch (error) {
              console.error("Error fetching order details:", error);
            }
          };

          return (
            <Link
              to="#"
              className="fw-medium link-primary"
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                if (originalOrder?._id) {
                  handleOrderClick(originalOrder._id);
                }
              }}
            >
              {transformedOrder.orderId}
            </Link>
          );
        },
      },
      {
        Header: "Customer",
        accessor: "customer_name",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Products",
        accessor: "products",
        disableFilters: true,
        filterable: true,
        Cell: ({ row }: { row: { original: any } }) => {
          const order = orders.find((o) => o._id === row.original._id);
          const products = order?.products || [];
          const productCount = products.length;
          const displayProducts = products.slice(0, 3);
          const remainingCount = productCount > 3 ? productCount - 3 : 0;

          const isOne = productCount === 1;
          const isTwo = productCount === 2;

          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    productCount === 1 ? "1fr" : "repeat(2, 1fr)",
                  gridTemplateRows: isTwo ? "1fr" : isOne ? "1fr" : "auto",
                  gap: "4px",
                  width: "90px",
                  height: isOne ? "90px" : isTwo ? "45px" : "90px", // Full height for single image
                }}
              >
                {displayProducts.map((item: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      borderRadius: "4px",
                      overflow: "hidden",
                      height: isOne ? "100%" : isTwo ? "45px" : "45px", // Use full height for single image
                      width: "100%",
                    }}
                  >
                    {item.product?.images?.[0] ? (
                      <img
                        src={item.product.images[0]}
                        alt={item.product.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // ensures full image is visible
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ fontSize: "10px" }}>No image</span>
                      </div>
                    )}
                  </div>
                ))}

                {remainingCount > 0 && (
                  <div
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    +{remainingCount}
                  </div>
                )}
              </div>
              <div style={{ marginTop: "4px", fontSize: "12px" }}>
                {products[0]?.product?.name || "Unknown Product"}
                {productCount > 1 && ` +${productCount - 1} more`}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Order Date",
        accessor: "order_date",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Delivery Date",
        accessor: "delivery_date",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Payment Method",
        accessor: "payment_method",
        disableFilters: true,
        filterable: true,
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   disableFilters: true,
      //   filterable: true,
      //   Cell: ({ value, row }: { value: string; row: any }) => {
      //     const [isEditing, setIsEditing] = useState(false);
      //     const [newStatus, setNewStatus] = useState(value);

      //     const statusOptions = [
      //       "Not processed",
      //       "Pending",
      //       "Inprogress",
      //       "Delivered",
      //       "Cancelled",
      //       "Returns",
      //     ];

      //     const handleStatusUpdate = async () => {
      //       try {
      //         // Add your API call here to update the status
      //         console.log(
      //           "Updating status for order:",
      //           row.original._id,
      //           "to:",
      //           newStatus
      //         );

      //         // Example API call (uncomment and modify as needed):
      //         // await updateOrderStatus(row.original._id, newStatus);

      //         // Update local state
      //         const updatedOrders = orders.map((order) =>
      //           order._id === row.original._id
      //             ? {
      //                 ...order,
      //                 products: order.products.map((p) => ({
      //                   ...p,
      //                   status: newStatus,
      //                 })),
      //               }
      //             : order
      //         );
      //         setOrders(updatedOrders);

      //         setIsEditing(false);
      //       } catch (error) {
      //         console.error("Failed to update status:", error);
      //         // Reset to original value on error
      //         setNewStatus(value);
      //       }
      //     };

      //     const getBadgeClass = (status: string) => {
      //       switch (status) {
      //         case "Delivered":
      //           return "badge bg-success-subtle text-success text-uppercase";
      //         case "Cancelled":
      //           return "badge bg-danger-subtle text-danger text-uppercase";
      //         case "Pending":
      //           return "badge bg-warning-subtle text-warning text-uppercase";
      //         case "Inprogress":
      //           return "badge bg-secondary-subtle text-secondary text-uppercase";
      //         case "Returns":
      //           return "badge bg-primary-subtle text-primary text-uppercase";
      //         case "Not processed":
      //           return "badge bg-info-subtle text-info text-uppercase";
      //         default:
      //           return "badge bg-success-subtle text-success text-uppercase";
      //       }
      //     };

      //     return (
      //       <div className="d-flex align-items-center gap-2">
      //         {isEditing ? (
      //           <div className="d-flex align-items-center gap-2">
      //             <select
      //               className="form-select form-select-sm"
      //               value={newStatus}
      //               onChange={(e) => setNewStatus(e.target.value)}
      //               style={{ minWidth: "120px" }}
      //             >
      //               {statusOptions.map((option) => (
      //                 <option key={option} value={option}>
      //                   {option}
      //                 </option>
      //               ))}
      //             </select>
      //             <button
      //               className="btn btn-sm btn-success"
      //               onClick={handleStatusUpdate}
      //               title="Save"
      //             >
      //               <i className="ri-check-line"></i>
      //             </button>
      //             <button
      //               className="btn btn-sm btn-secondary"
      //               onClick={() => {
      //                 setIsEditing(false);
      //                 setNewStatus(value);
      //               }}
      //               title="Cancel"
      //             >
      //               <i className="ri-close-line"></i>
      //             </button>
      //           </div>
      //         ) : (
      //           <>
      //             <span className={getBadgeClass(value)}>{value}</span>
      //             <button
      //               className="btn btn-sm btn-soft-primary p-1"
      //               onClick={() => setIsEditing(true)}
      //               title="Edit Status"
      //               style={{ minWidth: "24px", height: "24px" }}
      //             >
      //               <i
      //                 className="ri-pencil-line"
      //                 style={{ fontSize: "12px" }}
      //               ></i>
      //             </button>
      //           </>
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Status",
        accessor: "status",
        disableFilters: true,
        filterable: true,
        Cell: ({ value, row }: { value: string; row: any }) => {
          const [isEditing, setIsEditing] = useState(false);
          const [newStatus, setNewStatus] = useState(value);
          const [isUpdating, setIsUpdating] = useState(false);

          const statusOptions = [
            "Not processed",
            "Processing",
            "Shipped",
            "Delivered",
            "Cancelled",
          ];

          const handleStatusUpdate = async () => {
            try {
              setIsUpdating(true);
              const result = await updateOrderStatusById(
                row.original._id,
                newStatus
              );

              console.log("Status Update Response:", result);

              // Update local state
              setOrders((prevOrders) =>
                prevOrders.map((order) =>
                  order._id === row.original._id
                    ? { ...order, status: newStatus }
                    : order
                )
              );

              // Add more specific toast configuration
              toast.success(`Order status updated to ${newStatus}`, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });

              setIsEditing(false);
            } catch (error: any) {
              console.error("Failed to update status:", error);

              // Enhanced error toast
              toast.error(
                `Failed to update status: ${error.message || "Unknown error"}`,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );

              setNewStatus(value);
            } finally {
              setIsUpdating(false);
            }
          };

          const getBadgeClass = (status: string) => {
            switch (status) {
              case "Delivered":
                return "badge bg-success-subtle text-success text-uppercase";
              case "Cancelled":
                return "badge bg-danger-subtle text-danger text-uppercase";
              case "Pending":
                return "badge bg-warning-subtle text-warning text-uppercase";
              case "Inprogress":
                return "badge bg-secondary-subtle text-secondary text-uppercase";
              case "Returns":
                return "badge bg-primary-subtle text-primary text-uppercase";
              case "Not processed":
                return "badge bg-info-subtle text-info text-uppercase";
              default:
                return "badge bg-success-subtle text-success text-uppercase";
            }
          };

          return (
            <div className="d-flex align-items-center gap-2">
              {isEditing ? (
                <div className="d-flex align-items-center gap-2">
                  <select
                    className="form-select form-select-sm"
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                    style={{ minWidth: "120px" }}
                    disabled={isUpdating}
                  >
                    {statusOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-sm btn-success"
                    onClick={handleStatusUpdate}
                    title="Save"
                    disabled={isUpdating}
                  >
                    {isUpdating ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <i className="ri-check-line"></i>
                    )}
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => {
                      setIsEditing(false);
                      setNewStatus(value);
                    }}
                    title="Cancel"
                    disabled={isUpdating}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
              ) : (
                <>
                  <span className={getBadgeClass(value)}>{value}</span>
                  <button
                    className="btn btn-sm btn-soft-primary p-1"
                    onClick={() => setIsEditing(true)}
                    title="Edit Status"
                    style={{ minWidth: "24px", height: "24px" }}
                  >
                    <i
                      className="ri-pencil-line"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </button>
                </>
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }: { row: any }) => {
          const [isHovered, setIsHovered] = useState(false);

          return (
            <div className="text-center">
              <a
                href={`/orders-overview/${row.original._id}`}
                className="btn btn-soft-primary btn-sm btn-icon"
                title="View"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <i
                  className="ri-eye-fill align-bottom"
                  style={{ color: isHovered ? "black" : "#0d6efd" }}
                />
              </a>
            </div>
          );
        },
      },
    ],
    [orders] // Add orders as dependency since we're using it in the Cell function
  );

  if (loading) {
    return <div className="text-center py-4">Loading orders...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">Error: {error}</div>;
  }

  return (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={3000} />

      <TableContainer
        columns={columns}
        data={transformedOrders}
        iscustomPageSize={false}
        isBordered={false}
        customPageSize={pagination.limit}
        className="custom-header-css"
        tableClass="table-centered align-middle table-nowrap mb-0"
        theadClass="text-muted table-light"
        SearchPlaceholder="Search Orders..."
        manualPagination={true}
        pageCount={pagination.totalPages}
        currentPage={pagination.currentPage - 1} // Convert to 0-based for UI
        onPageChange={(page) => handlePageChange(page + 1)} // Convert back to 1-based
        onPageSizeChange={handlePageSizeChange}
      />

      {/* <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {(pagination.currentPage - 1) * pagination.limit + 1} to{" "}
          {Math.min(
            pagination.currentPage * pagination.limit,
            pagination.count
          )}{" "}
          of {pagination.count} orders
        </div>
        <div className="pagination-wrap hstack gap-2">
          <button
            className={`btn btn-sm btn-soft-primary ${
              pagination.currentPage === 1 ? "disabled" : ""
            }`}
            onClick={() =>
              setPagination((prev) => ({
                ...prev,
                currentPage: prev.currentPage - 1,
              }))
            }
            disabled={pagination.currentPage === 1}
          >
            Previous
          </button>
          <span className="text-muted">
            Page {pagination.currentPage} of {pagination.totalPages}
          </span>
          <button
            className={`btn btn-sm btn-soft-primary ${
              pagination.currentPage >= pagination.totalPages ? "disabled" : ""
            }`}
            onClick={() =>
              setPagination((prev) => ({
                ...prev,
                currentPage: prev.currentPage + 1,
              }))
            }
            disabled={pagination.currentPage >= pagination.totalPages}
          >
            Next
          </button>
        </div>
      </div> */}

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <h5 className="modal-title">Edit Order</h5>
        </Modal.Header>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            // Add your submit logic here (API call etc.)
            setShowEditModal(false);
          }}
        >
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="customername-field" className="form-label">
                Customer Name
              </label>
              <input
                type="text"
                id="customername-field"
                className="form-control"
                placeholder="Enter name"
                defaultValue={selectedOrder?.customerName} // or however you store it
                required
              />
            </div>

            {/* Add other fields like product, date, amount, payment method, delivery status similarly */}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ListViewTable;
